import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import './MobileNavBar.css';

const MobileNavBar = ({ user }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const tabs = [
        { id: 'hub', label: 'Ana Sayfa', icon: '🏠', path: '/hub' },
        { id: 'dagendas', label: 'Dagenda', icon: '📋', path: '/agendas' },
        { id: 'explore', label: 'Keşfet', icon: '🔍', path: '/explore' },
        { id: 'settings', label: 'Profil', icon: '👤', path: '/settings' }
    ];

    const handleTabClick = async (path) => {
        if (location.pathname !== path) {
            try {
                await Haptics.impact({ style: ImpactStyle.Light });
            } catch (e) {
                // Ignore if not on a platform supporting haptics
            }
            navigate(path);
        }
    };

    if (!user) return null;

    return (
        <nav className="mobile-bottom-nav">
            {tabs.map((tab) => (
                <button
                    key={tab.id}
                    className={`mobile-nav-item ${location.pathname === tab.path ? 'active' : ''}`}
                    onClick={() => handleTabClick(tab.path)}
                >
                    <span className="nav-icon">{tab.icon}</span>
                    <span className="nav-label">{tab.label}</span>
                </button>
            ))}
        </nav>
    );
};

export default MobileNavBar;
